import router from '@/router'
import request from '@/utils/request'
import store from '@/store'

export function focusedMessageId(query:Record<string,unknown>):number|null {
  const text=query.focusMessageId
  if(typeof text!=='string' || !/^[1-9]\d{0,9}$/.test(text))return null
  const id=Number(text);return Number.isSafeInteger(id) && id<=2147483647?id:null
}
export async function messageRecordRequest(kind:'ORDER'|'AUDIT'|'DRAWING',fallback:()=>Promise<any>){
  const route=router.currentRoute.value,id=focusedMessageId(route.query)
  const detail=route.query.focusOrderDetailId
  const identity=JSON.stringify([store.getters.token,store.getters.userInfo?.orgId,store.getters.userInfo?.roleId])
  const sameFocus=()=>{const now=router.currentRoute.value;return now.path===route.path && String(now.query.focusOrderDetailId)===String(detail) && String(now.query.detailChannel || '')===String(route.query.detailChannel || '') && identity===JSON.stringify([store.getters.token,store.getters.userInfo?.orgId,store.getters.userInfo?.roleId])}
  if(!id && typeof detail==='string' && /^[1-9]\d{0,9}$/.test(detail) && kind==='ORDER'){
    const response=await request({url:'order/allOrders/'+detail,method:'GET'})
    if(!sameFocus() || response.data?.path!==route.path || !Array.isArray(response.data.rows))throw new Error('订单定位或访问权限已变化')
    if(route.query.orderDetailEmbed==='1'){
      const selected=response.data.rows.find((row:any)=>String(row.id)===detail)
      if(!selected)throw new Error('订单不存在或无权访问')
      const related=await request.get('order/allOrders/'+detail+'/family')
      if(!sameFocus() || !Array.isArray(related.data?.rows))throw new Error('订单定位已变化')
      const family=related.data.rows.filter((row:any)=>String(row.orderId)===String(selected.orderId) && Number(row.orderType)===Number(selected.orderType))
      if(!family.some(row=>String(row.id)===detail))throw new Error('订单已不可访问，请重新打开')
      return {...response,data:family.filter((row:any)=>String(row.productCode || row.productId)===String(selected.productCode || selected.productId))}
    }
    return {...response,data:response.data.rows}
  }
  if(!id)return fallback()
  const response=await request({url:`order/messages/${id}/records`,method:'GET'})
  const value=response.data
  if(router.currentRoute.value.fullPath!==route.fullPath || value?.path!==route.path || value?.kind!==kind || !Array.isArray(value.rows))throw new Error('关联记录定位已变化，请重新打开消息')
  return {...response,data:kind==='ORDER'?value.rows:kind==='DRAWING'?value.rows[0]:{list:value.rows,total:value.rows.length,page:1,size:value.rows.length}}
}
